import { motion } from 'framer-motion'
import { Fragment } from 'react'
import { LEXICON_SLIDER_SCALE_SIZE } from './LexiconSlider'
import type { Slide } from './LexiconSliderComponent'

export const ContentSlide = ({
  slide,
  minHeight,
}: {
  slide: Slide
  minHeight: number | undefined
}) => {
  const whileHover = !!minHeight
    ? {
        minWidth: `${minHeight + LEXICON_SLIDER_SCALE_SIZE}px`,
        minHeight: `${minHeight + LEXICON_SLIDER_SCALE_SIZE}px`,
        backgroundColor: '#508090',
      }
    : {}
  return (
    <Fragment>
      {slide.hasContent ? (
        <>
          <motion.div
            //TODO: this has to be moved to a other component
            style={{
              minWidth: `${minHeight}px`,
              minHeight: `${minHeight}px`,
              backgroundColor: '#2b2d36',
            }}
            className={'keen-slider__slide'}
            // animate={divAnimationControls}
            // onHoverStart={() => {
            //   divAnimationControls.start(divAnimationVariants.anim)
            // }}
            whileHover={whileHover}
          >
            <div aria-hidden className="flex flex-col justify-center h-full">
              {slide.slide}

              {slide.title && (
                <div className="h-px-20 mt-px-24 text-px-16 leading-px-24 text-center text-accentroWhite-full">
                  {slide.title}
                </div>
              )}
            </div>
          </motion.div>
        </>
      ) : (
        <div
          style={{
            minWidth: `${minHeight}px`,
            minHeight: `${minHeight}px`,
            backgroundColor: 'rgba(43, 45, 54, 0.3)',
          }}
          className={'keen-slider__slide'}
        >
          <div aria-hidden className="flex flex-col justify-center h-full">
            {slide.slide}
            {slide.title && (
              <div className="h-px-20 mt-px-24 text-px-16 leading-px-24 text-center text-accentroWhite-full">
                {slide.title}
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  )
}
